import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';
import logo from '../../../public/logo-hori.png';

const mainImage =
  'https://file.hoaphat.com.vn/hoaphat-com-vn/2022/11/trung-1.jpg';

const features = [
  'Cung cấp danh mục sản phẩm trứng đa dạng, phù hợp nhiều nhu cầu chế biến',
  'Hệ thống kho lưu trữ lớn, bảo quản đạt chuẩn, nguồn hàng luôn có sẵn',
  'Dịch vụ giao hàng linh hoạt, thuận tiện cho mọi đối tác',
];

const AboutUs = () => {
  return (
    <div className="container py-8 md:py-16 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        {/* Image Section - Left */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative w-full h-[300px] md:h-[380px] lg:h-[480px]"
        >
          {/* Main Image Container */}
          <div className="relative w-full h-full rounded-3xl overflow-hidden">
            <Image
              src={mainImage}
              alt="Nông dân và trang trại gà"
              fill
              className="object-cover"
              sizes="(max-width: 1024px) 100vw, 50vw"
            />
          </div>

          {/* Grass Decoration at Bottom */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="absolute -bottom-4 left-0 right-0 h-16 md:h-24"
          ></motion.div>
        </motion.div>

        {/* Content Section - Right */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col gap-6 md:gap-8"
        >
          {/* Small Heading */}
          {/* <motion.p
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-primary text-[14px] md:text-[16px] font-semibold uppercase tracking-wider"
          >
            Về chúng tôi
          </motion.p> */}

          {/* Main Heading */}
          <Image src={logo} alt="About Us" width={100} height={100} />
          <motion.h2
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-[28px] md:text-[32px] uppercase font-bold text-gray2 leading-tight"
          >
            Bền chất lượng, vững niềm tin
          </motion.h2>

          {/* Description Paragraphs */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-[16px] md:text-[18px] text-gray-600 leading-relaxed"
          >
            <p className="mt-3">
              Chúng tôi cung cấp các dòng sản phẩm trứng đa dạng, đáp ứng nhu
              cầu của siêu thị, nhà hàng, bếp ăn công nghiệp và hệ thống phân
              phối. Với kho lưu trữ lớn, hàng hóa luôn có sẵn cùng dịch vụ giao
              hàng thuận tiện, linh hoạt, Trường Thọ Food cam kết mang lại giải
              pháp ổn định, tin cậy cho mọi đối tác.
            </p>
          </motion.div>

          {/* Features List
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col gap-4"
          >
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
                className="flex items-start gap-3"
              >
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center mt-1">
                  <svg
                    className="w-4 h-4 text-primary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <p className="text-[16px] md:text-[18px] text-gray-700 leading-relaxed">
                  {feature}
                </p>
              </motion.div>
            ))}
          </motion.div> */}

          {/* Read More Button */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="pt-2"
          >
            <Link
              href="/about"
              className="inline-flex items-center gap-2 text-primary border border-primary px-6 py-2 rounded-full font-semibold text-[16px] md:text-[18px] hover:bg-primary hover:text-white transition-all duration-300 group"
            >
              Đọc thêm
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
